module.exports = __webpack_public_path__ + "img/stations.c386b311.png";